import React, { useState, useRef, useEffect } from 'react';
import storyVideo from '../../images/story_video/1122.mp4';
import './style.css';

const LocalVideoModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const videoRef = useRef(null);

    const openModal = () => {
        setIsLoading(true);
        setIsOpen(true);
        // Auto-play video when modal opens
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.play().catch(() => {
                    // Handle autoplay restriction
                });
            }
            setIsLoading(false);
        }, 300);
    };

    const closeModal = () => {
        setIsOpen(false);
        // Pause video when modal closes    
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    // Close modal on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen) {
                closeModal();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            {/* Video Button */}
            <div className="video-btn">
                <ul>
                    <li>
                        <button className="wrap" onClick={openModal}>
                            <i className="fi flaticon-play" aria-hidden="true"></i>
                        </button>
                    </li>
                </ul>
            </div>

            {/* Modal Overlay */}
            {isOpen && (
                <div className="local-video-modal-overlay" onClick={handleBackdropClick}>
                    <div className="local-video-modal-content">
                        <button className="close-btn" onClick={closeModal}>
                            ✕
                        </button>
                        <div className="video-container">
                            {isLoading && (
                                <div className="video-loading">
                                    <div className="loading-spinner"></div>
                                    <p>Loading Story...</p>
                                </div>
                            )}
                            <video
                                ref={videoRef}
                                className="story-video"
                                controls
                                preload="metadata"
                                poster=""
                            >
                                <source src={storyVideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LocalVideoModal;
